import { useSelector } from 'react-redux';

export default function useAuth() {
  const accessToken = useSelector((state) => state.registerReducer.token);
  return { 
    isAuth: !!accessToken,
    accessToken, 
  };
}